var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './Drawer.css';
import cx from 'classnames';
import BaseDrawer from './BaseDrawer';
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer(props) {
        var _this = _super.call(this, { noScrollClassName: styles.noScroll }) || this;
        _this.onCloseCb = null;
        _this.shouldCloseOnNavigation = true;
        _this.state = {
            visible: false,
            children: null,
            className: '',
            customStyles: undefined
        };
        _this.close = function () {
            _this.shouldCloseOnNavigation = true;
            _this.setState(function (prevState) {
                if (prevState.visible) {
                    requestAnimationFrame(_this.unlockBodyScroll);
                    return {
                        visible: false,
                        customStyles: undefined
                    };
                }
                return null;
            });
        };
        _this.onOverlayClick = function () {
            _this.close();
            _this.onCloseCb && _this.onCloseCb();
            _this.onCloseCb = null;
        };
        return _this;
    }
    Drawer.prototype.open = function (_a) {
        var children = _a.children, onClose = _a.onClose, _b = _a.shouldCloseOnNavigation, shouldCloseOnNavigation = _b === void 0 ? true : _b, className = _a.className, customStyles = _a.styles;
        this.shouldCloseOnNavigation = shouldCloseOnNavigation;
        this.setState({
            children: children,
            visible: true,
            className: className,
            customStyles: customStyles
        });
        requestAnimationFrame(this.lockBodyScroll);
        this.onCloseCb = onClose || null;
    };
    Drawer.prototype.shouldDrawerCloseOnNavigation = function () {
        return this.shouldCloseOnNavigation;
    };
    Drawer.prototype.render = function () {
        var _a;
        var customStyles = this.state.customStyles;
        return (<div className={cx(styles.container, (_a = {}, _a[styles.visible] = this.state.visible, _a))}>
				<div onClick={this.onOverlayClick} className={styles.overlay}/>
				<div id="bottom-sheet-content" className={cx(styles.content, this.state.className)} style={customStyles}>
					{this.state.visible ? this.state.children : null}
				</div>
			</div>);
    };
    return Drawer;
}(BaseDrawer));
export default Drawer;
